/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  documents:null,
};

export const site = createSlice({
  name: 'site',
  initialState,
  reducers: {
    setSiteDocuments: (state, action) => {
      state.documents = action.payload;
    },
    
  },
});

export const {
  setSiteDocuments
} = site.actions;

export default site.reducer;
